<template>
	<div class="book-card">

		<div class="book-card__cover" :class="{
			'book-card__cover_empty': !book.image
		}">

			<a href="#" @click.prevent="showGallery" class="stretched-link book-card__link">
				<img v-if="book.image" class="book-card__image" :src="picture(book.image, 340)">
			</a>
<!--			<progress class="book-card__progress" title="Остановился на 10 странице" value="10" max="100"></progress>-->
		</div>

		<div class="pt-2 p-md-3 position-relative">
			<h3 class="book-card__title">
				<router-link :to="{name: 'book-view', params: {
					idBook: book.id,
					idShelf: shelf.id
				}}" class="stretched-link book-card__link">{{book.name}}</router-link>
			</h3>

			<p class="book-card__meta" v-if="book.author">{{book.author}}</p>
			<p class="book-card__meta" v-if="book.publish_house">{{book.publish_house}}</p>
		</div>

		<vue-easy-lightbox
			:visible="gallery.visible"
			:index="gallery.index"
			:imgs="gallery.images"
			@hide="closeGallery"
		></vue-easy-lightbox>

	</div>
</template>
<script>
export default {
	props: {
		book: {
			type: Object,
			required: true
		},
		shelf: {
			type: Object,
			required: true,
		}
	},
	data() {
		return {
			gallery: {
				images: [],
				index: 0,
				visible: false
			},
		}
	},
	methods: {
		showGallery() {
			if (this.book.images.length) {

				this.gallery.images = this.book.images.map(file => {
					return {
						src: this.picture(file.image),
						title: file.comment
					}
				});

				this.gallery.visible = true;

			} else {

				this.$router.push({name: 'book-view', params: {
					idBook: this.book.id,
					idShelf: this.shelf.id
				}});

			}
		},

		closeGallery() {
			this.gallery.visible = false;
		},
	}
}
</script>
<style lang="sass">
.book-card
	position: relative
	//display: flex
	//align-items: center

	&__cover
		position: relative
		padding-bottom: 100%
		border-radius: 3px
		background-color: white

		.book-card__link
			position: absolute
			top: 0
			left: 0
			right: 0
			bottom: 0

	&__cover_empty
		background-image: url('~@/assets/icon-image.svg')
		background-position: center
		background-repeat: no-repeat
		background-size: 42px

	&__image
		position: absolute
		top: 4px
		left: 4px
		width: calc(100% - 8px)
		height: calc(100% - 8px)
		object-fit: contain
		object-position: center

	&__link
		&::after
			top: -1px
			left: -1px
			right: -1px
			bottom: -1px
			border-radius: 5px

		&:hover
			&::after
				outline: 2px solid rgba($primary, 0.25)

		&:active
			&::after
				outline: 2px solid rgba($primary, 0.75)

	&__progress
		position: absolute
		left: 5px
		bottom: 5px
		width: calc(100% - 10px)
		height: 7px
		background-color: rgba(black, 0.5)
		border: none
		overflow: hidden

		&::-moz-progress-bar
			background-color: $primary
		&::-webkit-progress-value
			background-color: $primary

	&__title
		font-size: 1rem
		margin-bottom: 0
		font-weight: 200
		text-decoration: underline

		> a
			color: #222

	&__meta
		color: #999
		font-size: 0.85em
		margin-bottom: 0
</style>